<!--
 * @file iconfont组件
 * @author 小白
 -->
<template>
  <svg class="icon" :class="type" aria-hidden="true">
    <use :xlink:href="'#' + type" />
  </svg>
</template>

<script>
export default {
  name: "IconFont",
  props: {
    type: {
      type: String,
      default: "",
      require: true
    }
  }
};
</script>

<style lang="scss" scoped>
.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>
